import { styled } from 'styled-components'

import { breakpoints } from '@src/constants/breakpoints'

export const SideMenuContainer = styled.aside`
  flex: 0 0 180px;
  padding-left: 14px;
  padding-top: 16px;

  height: auto;
  max-height: 100%;
  min-height: 85vh;
  overflow-y: auto;

  display: flex;
  flex-direction: column;

  @media (max-width: ${breakpoints.tablet - 1}px) {
    display: none;
  }
`

export const CategoryList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`

export const CategoryItem = styled.li`
  margin-bottom: 8px;
  label {
    cursor: pointer;
    font-size: 14px;
  }
`

export const LetterHeader = styled.h4`
  font-size: 14px;
  font-weight: 600;
  margin: 12px 0 4px 6px;
  color: ${({ theme }) => theme.colors.brand};
`

export const Count = styled.span`
  padding-left: 8px;
  font-weight: 600;
  font-size: 11px;
  opacity: 0.4;
`
